import { InputModalHost } from 'ui/common/prompt-confirmation/input-modal-host';
import * as React from 'react';
import { ShareCaseModal } from './share-case-modal';

/**
 * Conditionally render the component as a modal, or a UI element to trigger the modal
 */
export const ShareCase = props => (

  <InputModalHost {...props}>
  {
    modalProps => modalProps.isOpen
      ?
        <ShareCaseModal {...props} {...modalProps} />
      :        
        typeof props.children === 'function' ? props.children(modalProps) : null
  }
  </InputModalHost>
);
